module.exports = __webpack_public_path__ + "assets/img/help_image01-2@2x.d4216331.png";